import CapabilityModal from './CapabilityModal';

export default CapabilityModal;
